import React, { useRef, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import css from './fitlerModal.module.css';

import { Button } from '../../../../components';
import { FormattedMessage } from 'react-intl';
import { initElbScope } from '../../../../analytics/trackElbAction';

const closeIcon = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769083049/socialbnb/containers/SearchPage/SearchFiltersPrimary/filterModal/assets/closeIcon.svg';

const FilterModal = ({ isOpen, onClose, children, clearFilter, totalItems }) => {
  const modalRef = useRef();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const handleClickOutside = event => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'hidden';
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = '';
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);

  // The modal body lives in a portal that only exists while open, so Walker's
  // page scan never sees it — register the subtree each time it opens.
  useEffect(() => {
    if (isOpen && mounted) initElbScope(modalRef.current);
  }, [isOpen, mounted]);

  if (!isOpen || !mounted) return null;

  const modalContent = (
    <div className={css.modalOverlay}>
      <div
        className={css.modalContent}
        ref={modalRef}
        data-elb="searchp"
        data-elbaction="visible:vis filterModal"
      >
        <div className={css.filterheader}>
          <div>
            <FormattedMessage id="SearchFiltersMobile.filter" />
          </div>
          <div className={css.closeButton} onClick={onClose}>
            <img src={closeIcon} alt="close icon" />
          </div>
        </div>
        <div className={css.modalBody}>{children}</div>
        <div className={css.modalFooter}>
          <div
            onClick={clearFilter}
            className={css.clearButton}
            data-elbaction="click: click filterModalReset"
          >
            <FormattedMessage id="SearchFiltersMobile.resetAll" />
          </div>
          <div>
            <Button
              className={css.submitButton}
              type="submit"
              onClick={onClose}
              inProgress={false}
              disabled={false}
              ready={false}
              data-elbaction={`click: click filterModalApply-${totalItems}`}
            >
              <FormattedMessage
                id="SearchFiltersMobile.foundResults"
                values={{ count: totalItems }}
              />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default FilterModal;
